module.exports = __webpack_public_path__ + "img/eduSmallBanner.0b6e101f.png";